if (!customElements.get("swiper-slider")) {
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.slideContainer = this.querySelector(
          "[data-swiper]:not([data-swiper-thumbs])"
        )),
        (this.slides = this.querySelectorAll("[data-swiper-slide]")),
        (this.sliderOptions = this.applyDefaultOptions(
          this.getSliderOptions(this.dataset.swiperOptions)
        )),
        (this.activeIndex = 0),
        (this.initialized = !1),
        this.dataset.swiperThumbs &&
          (this.thumbnails = this.querySelector("[data-swiper-thumbs]")),
        this.dataset.customEvent &&
          this.attachCustomListeners(this.dataset.customEvent),
        this.slideContainer && this.slides.length > 0
          ? (document.addEventListener(
              "DOMContentLoaded",
              this.initializeSwiper.bind(this)
            ),
            document.addEventListener(
              "shopify:section:load",
              this.initializeSwiper.bind(this)
            ),
            window.addEventListener("resize", this.handleResize.bind(this)),
            this.addEventListener("go-to-slide", this.goToSlide.bind(this)))
          : console.warn("SwiperSlider - Slider or Slides Not Found");
    }
    attachCustomListeners(i) {
      "swiper_event" === i &&
        document.addEventListener("swiper_event", this.updateSlides.bind(this));
    }
    updateSlides(i) {}
    applyDefaultOptions(i) {
      return void 0 === i.loop && (i.loop = !0), (i.speed = 400), i;
    }
    getSliderOptions(i) {
      try {
        return JSON.parse(i);
      } catch (e) {
        return console.log(e), {};
      }
    }
    initializeSwiper() {
      window.Swiper && !this.initialized
        ? ((this.initialized = !0),
          this.thumbnails && this.setThumbnails(),
          (this.slider = new Swiper(this.slideContainer, this.sliderOptions)),
          this.initializeSliderEventListeners())
        : window.Swiper || console.warn("SwiperSlider - Swiper.js not found");
    }
    handleResize(i) {
      this.slider &&
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
    }
    goToSlide(i) {
      let e = i.detail.index;
      if (!e && i.detail.position) {
        let t = this.querySelector(
          "[data-position='" + i.detail.position + "']"
        );
        e = [...t.parentNode.children].indexOf(t);
      }
      (0 == e || e) && this.slider.slideTo(e);
    }
    setThumbnails() {
      let i = this.thumbnails,
        e = this.getSliderOptions(this.thumbnails.dataset.swiperOptions),
        t = new Swiper(i, e);
      (this.sliderOptions.thumbs = { swiper: t }),
        (this.sliderOptions.on = {
          slideChange: function () {
            let i = this.activeIndex;
            this.thumbs.swiper.slideTo(i - 1);
          },
        });
    }
    initializeSliderEventListeners() {}
  }
  customElements.define("swiper-slider", i);
}
